const none = '0px';
const xxxxSmall = '4px';
const xxxSmall = '8px';
const xxSmall = '12px';
const xSmall = '16px';
const small = '24px';
const medium = '32px';
const large = '48px';
const xLarge = '64px';
const xxLarge = '80px';
const xxxLarge = '104px';
const xxxxLarge = '144px';

const Spacings = {
  none,
  xxxxSmall,
  xxxSmall,
  xxSmall,
  xSmall,
  small,
  medium,
  large,
  xLarge,
  xxLarge,
  xxxLarge,
  xxxxLarge,
};

export default Spacings;
